import { createSelector } from 'reselect';
import moment from 'moment';

const sessionsSelector = state => state.followUps.followUps;

export const selectNewSessions = createSelector(
  sessionsSelector,
  sessions =>
    sessions.get('data')
      ? sessions
          .get('data')
          .filter(session => session.get('status') === 'submitted')
          .toJS()
      : null
);

export const selectBookedSessions = createSelector(
  sessionsSelector,
  sessions =>
    sessions.get('data')
      ? sessions
          .get('data')
          .filter(session => {
            return session.get('status') === 'accepted' && moment(session.get('accepted_session_date')).isAfter();
          })
          .toJS()
      : null
);

export const selectCompletedSessions = createSelector(
  sessionsSelector,
  sessions =>
    sessions.get('data')
      ? sessions
          .get('data')
          .filter(session => {
            return session.get('status') === 'accepted' && moment(session.get('accepted_session_date')).isBefore();
          })
          .toJS()
      : null
);

export const selectHistorySessions = createSelector(
  sessionsSelector,
  sessions =>
    sessions.get('data')
      ? sessions
          .get('data')
          .filter(session => {
            return (
              (session.get('status') === 'accepted' && moment(session.get('accepted_session_date')).isBefore()) ||
              ['no_response', 'rejected', 'cancelled_by_user', 'cancelled_by_admin'].indexOf(session.get('status')) !==
                -1
            );
          })
          .toJS()
      : null
);



// WEBPACK FOOTER //
// ./src/follow-ups/redux/selectors.js